export default __webpack_public_path__ + "static/34-ddbb333222c6d36d0c356d1e77113b2e.png";